import React,{PureComponent} from 'react'
import {Switch,Route, Redirect} from 'react-router-dom';

import AfterSale from "@pages/AfterSale/index";
// import ClaimDemageInfo from "@pages/AfterSale/ClaimDemageInfo/index"; //索赔详情
import AfterSaleInitiated from "@pages/AfterSale/afterSalesDetail2.0/initiated"; // 索赔发起
import AfterSaleDetail from "@pages/AfterSale/afterSalesDetail2.0/detail.js"; // 索赔详情
import DamageDetail from "@pages/AfterSale/afterSalesDetail3.0/detail";//破损登记详情
 

// 售后索赔 管理
class AfterSaleRouter extends PureComponent{
    render() {
        return (
            <Switch>
                <Route path="/afterSale/customerInitiated" render={(props) =><AfterSale {...props} key={"customerInitiated"} />} />
                <Route path="/afterSale/warehouseInitiated" render={(props) =><AfterSale {...props} key={"warehouseInitiated"} />} />
                <Route path="/afterSale/damageDetail" component={DamageDetail} />
                <Route path="/afterSale/claim-demage-info" component={AfterSaleDetail} />
 				<Route path="/afterSale/initiated" component={AfterSaleInitiated} />
				<Route path="/*" render={(props) => <Redirect to="/afterSale/customerInitiated" />} />
            </Switch>
        );
    }
}
export default AfterSaleRouter;
